export const BENEFICIARY_SUPPORT_PANEL_URL = '/beneficiary-support-panel';
